import Payment from './Payment'

export default Payment


// WEBPACK FOOTER //
// ./src/features/OrderDetails/containers/Payment/index.js